import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Plus, BookOpen, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

export default function KnowledgeBase() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ title: "", content: "", category: "general" });

  const load = async () => setItems((await api.get("/knowledge")).data);
  useEffect(() => { load(); }, []);
  const create = async () => { await api.post("/knowledge", f); toast.success("Added"); setOpen(false); setF({title:"",content:"",category:"general"}); load(); };
  const del = async (id) => { await api.delete(`/knowledge/${id}`); load(); };

  return (
    <div className="p-4 lg:p-6 space-y-4 max-w-5xl mx-auto">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2"><BookOpen className="w-6 h-6 text-indigo-600"/>Knowledge Base</h1>
          <p className="text-sm text-slate-500">Company knowledge Aria uses to answer accurately (no hallucination)</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="new-kb-button"><Plus className="w-4 h-4 mr-1"/>Add article</Button>
          </DialogTrigger>
          <DialogContent className="bg-white">
            <DialogHeader><DialogTitle>New knowledge article</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>Title</Label><Input value={f.title} onChange={(e)=>setF({...f,title:e.target.value})} data-testid="kb-title-input"/></div>
              <div><Label>Category</Label><Input value={f.category} onChange={(e)=>setF({...f,category:e.target.value})}/></div>
              <div><Label>Content</Label><Textarea rows={6} value={f.content} onChange={(e)=>setF({...f,content:e.target.value})} data-testid="kb-content-input"/></div>
            </div>
            <DialogFooter><Button onClick={create} className="bg-emerald-600 hover:bg-emerald-700" data-testid="save-kb-button">Save</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map(k => (
          <Card key={k.id} className="p-5 border-slate-200" data-testid={`kb-card-${k.id}`}>
            <div className="flex items-start justify-between">
              <div className="font-semibold text-slate-900">{k.title}</div>
              <Button size="icon" variant="ghost" onClick={()=>del(k.id)} data-testid={`delete-kb-${k.id}`}><Trash2 className="w-4 h-4 text-rose-500"/></Button>
            </div>
            <div className="text-xs text-slate-500 uppercase mt-1">{k.category}</div>
            <div className="text-sm text-slate-700 mt-3 whitespace-pre-wrap">{k.content}</div>
          </Card>
        ))}
        {items.length === 0 && <div className="col-span-full text-center p-12 text-slate-500">No articles yet</div>}
      </div>
    </div>
  );
}
